import _get from 'lodash/get';
import { Google, Pixall } from '../analytics/index.js';
import { sanitizeValue } from './helpers/index.js';
import { getInventoryOwnerById } from '../utilities/index.js';
export async function sendTabEvent(_ref, options) {
  let {
    data = {},
    state = {},
    dataLayer = {}
  } = _ref;
  if (options === void 0) {
    options = {};
  }
  const componentType = sanitizeValue(_get(data, 'componentType', ''));
  const label = sanitizeValue(_get(data, 'label', ''));
  const inventoryId = dataLayer.vehicle?.id;
  const inventory = getInventoryOwnerById(state, inventoryId);
  let pixallLabel = '';
  if (label === 'consumer-reviews') {
    pixallLabel = 'cnsm_rtg';
  } else if (label === 'expert-review') {
    pixallLabel = 'expt_rvw';
  } else {
    pixallLabel = 'vw_cnsm_rvws';
  }
  Google.sendClickEvent({
    eventElement: 'dealer_rating',
    eventAction: 'tab',
    eventResult: `${componentType}::${label}`
  }, options);
  Pixall.sendClickEvent({
    eventSource: 'vehicle',
    eventType: 'click',
    label: pixallLabel,
    pageType: 'vdp',
    program: 'DealerDotCom',
    inventory,
    pixallData: {
      clickTypeToListingType: true
    }
  }, dataLayer, options);
  return {};
}
export default {
  sendTabEvent
};